import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  theme: 'light',
  snackBarStates: {
    message: '',
    severity: '',
    open: false,
    autoHideDuration: 5000
  },
}

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setTheme: (state, action) => {
      state.theme = action.payload
    },
    setSnackBarStates: (state, action) => {
      state.snackBarStates = action.payload;
    },
  },
})

export const {
  setTheme,
  setSnackBarStates
} = uiSlice.actions

export default uiSlice.reducer
